import React, { useEffect, useState } from 'react';
import image from '../../photos/Groupe 26 1.png';
import image1 from '../../photos/cercles 1.png'
import image2 from '../../photos/check-mark 1.png'
import image3 from '../../photos/Group 1.svg'
import image4 from '../../photos/Groupe 11.svg'
import image5 from '../../photos/Group 2.svg'
import "./PopupComponent.css"
import Popup from '../Popup';
import { useForm } from 'react-hook-form';

const PopupComponent = (props) => {
  const [buttonPopup, setButtonPopup] = useState(false);
  const { t } = props
  let handler = props.handler;
  const [showModal,setShowModal]=useState(false);

  // const openModal = () => {
  //   setShowModal(true);
  // };

   const closeModal = () => {
     setShowModal(false);
  };
  

  const modalStyle = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, 
    },
    modal: {
      background: 'white',
      backgroundImage: `url("${image1}")`,
      backgroundSize: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'cover',
      paddingLeft:'5%',
      paddingRight:'5%',
      borderRadius: '8px',
      width: '90%',
      height: 'auto',
      zIndex: '10000', 
      maxHeight:'100vh',
      overflowY:'auto',

    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
    },
    closeBtn: {
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      fontSize: '20px',
      color: '#333',
      position: 'relative',
      left: '71px',
    },
    body: {
     
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    img:{
      width:'45px',
      height:'45px',
     },
    title:{
    fontSize: '36px',
    fontWeight: '700',
    lineHeight:'1.7',
    },
    texte:{
     marginBottom:'13px',
    },
    txt:{
        fontSize: '22px',
        fontWeight: '600',
        color:' #00315D',
        marginLeft: '20px',
    },
    input:{
    backgroundColor: '#fff',
    borderRadius: '6px',
    position: 'relative',
    margin: '24px 0px 24px 0px',
    paddingLeft: '50px;',
    height:'47px'
},
iconinput:{
    position: 'absolute',
    left: '11px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#555',
    pointerEvents: 'none',
},
verticalline:{
    borderLeft: '1px solid #ccc', 
    height: '100%', 
    marginRight:' 10px' ,
    position: 'absolute',
    height: '77% ',
    marginRight: '12px',
    left: '45px',
    margin: '0px 4px 0px 1px',
    top: '5px',
},
inputStyle:{
    paddingLeft:'60px',
    borderRadius:'8px',
    paddingTop: '10px',
    paddingBottom:' 10px'

},
btn:{
    background:' rgb(0, 159, 222)',
    borderRadius: '8px',
    color: 'white',
    border: 'none',
    padding: '65px',
    width: '100%',
    fontSize:'18px',
    fontWeight:'600'
},
pC:{
    
fontSize: '18px',
fontWeight:'600',
color:'#00315D'

},
close:{
  position: 'relative',
  textAlign: 'right',
}
    

  };
  
  const initialValues = { yourname: "popup", youremail: "",numtel:"", yourmessage: "" };
  const [formState, setFormState] = useState(initialValues);
  const letters = /^[A-Za-z0-9._,.:;*$"'#?!^[{}()\]\\\-\+=@é àçèâêîû/ô._\s-]+$/;
  const validEmail = /^[a-zA-Z0-9._:$!%-à]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,3}$/;
  const validNumtel = /^[+]+[0-9]{10,16}$/;
  const [existError, setExistError] = useState(false);



  const {
    formState: { errors },
  } = useForm();

  const handleFieldChange = (field, e) => {
    !errors.yourmessage && (errors.yourmessage = {});
    !errors.youremail && (errors.youremail = {});
    !errors.numtel && (errors.numtel = {});
    
   
    setFormState({
      ...formState,
      [field]: e.target.value,
    });

    if (field === "yourmessage") {
      if (e.target.value.length < 5) {
        errors.yourmessage.message = "La longueur doit être de 5 ou plus";
        setExistError(false);
      } else {
        errors.yourmessage = {};
      }
    }

    if (field === "youremail") {
      if (e.target.value.length < 5) {
        errors.youremail.message = "La longueur doit être de 5 ou plus";
        setExistError(false);
      } else if (!validEmail.test(e.target.value)) {
        errors.youremail.message = "L’adresse e-mail n’est pas valide.";
        setExistError(false);
      } else {
        errors.youremail = {};
      }
    }
    if (field === "numtel"){
      if (!validNumtel.test(e.target.value)) {
        errors.numtel.message = "Le code pays est requis ( exp '+33612345678' )";
        setExistError(false);
      }else {
        errors.numtel = {};
      }}
    };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    !errors.yourname && (errors.yourname = {});
    !errors.yourmessage && (errors.yourmessage = {});
    !errors.youremail && (errors.youremail = {});
  
    !errors.numtel && (errors.numtel = {});
    console.log("Form state before validation:", formState);
    var verifError = true;


    if (!formState.youremail) {
      errors.youremail.message = "Ce champ est Obligatoire";
      verifError = false;
    } else if (formState.youremail.length < 5) {
      errors.youremail.message = "La longueur doit être de 5 ou plus";
      verifError = false;
    } else if (!validEmail.test(formState.youremail)) {
      errors.youremail.message = "L’adresse e-mail n’est pas valide.";
      verifError = false;
    }
 
    if (!formState.numtel) {
      errors.numtel.message = "Veuillez saisir un numéro de téléphone"; 
      verifError = false;
    } 
    else if (!validNumtel.test(formState.numtel)) {
      errors.numtel.message = "Le code pays est requis.(exp '+33 612 34 56 78')"; 
      verifError = false;
    }
 

    verifError && handler(e, formState)
    verifError && e.target.reset()
    setExistError(verifError);

    console.log("Errors after validation:", errors);
    if (verifError) {
      console.log("Form data:", formState);
     
      e.target.reset();
      setExistError(verifError);
      console.log("Formulaire soumis avec succès");
    } else {
      console.log("Erreurs:", errors);
    }
  };
  useEffect(() => {
    const hasPopupBeenShown = sessionStorage.getItem('popupShown');

    if (!hasPopupBeenShown) {
      const timer = setTimeout(() => {
        setShowModal(true);
        sessionStorage.setItem('popupShown', 'true'); 
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, []); 




  return (
      <>
      <div className="background">
      <img className={"cercles" } src="/images/allPages/cercles.svg" alt="Cercles" />
      </div>
     
        {showModal && (
          <>
          <div className={`overlay ${!existError ? 'overlay' : 'close'}`}>
            
            <div style={modalStyle.modal}>
            <div className='close'>
             <button onClick={closeModal} className='closeBtn'>
                &times;
              </button>
              </div> 
              <div className='row align-items-center'>
                <img src={image} alt='' className='img-fluid col-auto'  />
                <h2 className='col-lg titre' >Recevez <span style={{color:'#009FDE'}}>un audit gratuit </span>et bénéficiez d'une remise de 
                <span style={{color:'#009FDE'}}> 10% sur tout nouveau projet </span></h2>
              </div>


            <div className='row align-items-center mt-lg-5' style={modalStyle.body}>
                <div className='col-lg-6'>
                    <div  className='texte d-flex align-items-center'>
                     <img src={image2} alt='check' className='img' /> 
                      <span className='txt'>Améliorez votre visibilité</span>  
                    </div>
                    <div  className='texte d-flex align-items-center'>
                    <img src={image2} alt='check' className='img'/> 
                        <span className='txt'>Augmentez le trafic sur votre site web</span>
                    </div>
                    <div className='texte d-flex align-items-center'>
                    <img src={image2} alt='check' className='img'/> 
                       <span className='txt'>Obtenez plus de lead qualifié</span>
                    </div>
                    <div className='texte d-flex align-items-center'>
                    <img src={image2} alt='check' className='img' /> 
                       <span className='txt'>Boostez votre chiffre d’affaire</span>
                    </div>
                </div>
                <div className='col-lg-6'>
                <form className="from" onSubmit={handleFormSubmit} method="POST">
  <div style={modalStyle.input}>
    <img src={image3} alt='' className='img-fluid'  style={modalStyle.iconinput}/>
    <div style={modalStyle.verticalline}></div>
    <input type='text' 
         id='email' 
         name='youremail'
         className='form-control inputStyle' 
         placeholder='Email' 
         onChange={(e) => handleFieldChange("youremail", e)} />
          {errors.youremail && (<small className="text-danger">{errors.youremail.message}</small>)}
  </div>
  <div style={modalStyle.input}>
    <img src={image4} alt='' className='img-fluid'  style={modalStyle.iconinput} />
    <div style={modalStyle.verticalline}></div>
    <input 
    type='tel' 
    name="numtel"
    id='tel' 
    onChange={(e) => handleFieldChange("numtel", e)}
    className='form-control inputStyle' 
    placeholder='+XXX XXX XXX XXXX' />
     {errors.numtel && (
                <small className="text-danger">
                  {errors.numtel.message}
                </small>
              )}
  </div>
  <div style={modalStyle.input}>
    <img src={image5} alt='' className='img-fluid' style={modalStyle.iconinput} />
    <div style={modalStyle.verticalline}></div>
    <input type='text'  
    name="yourmessage" 
    id='website' 
    onChange={(e) => handleFieldChange("yourmessage", e)}
    className='form-control inputStyle'  
    placeholder='Site Web' />
  </div>
  <div style={modalStyle.input}>
    <button className='btn' type="submit"onClick={() => setButtonPopup(true)} >Envoyer</button>
   
  </div>
  </form>
</div>
        <div className='text-center mt-4'> 
            <p style={modalStyle.p}><a href='https://oxton-digital.com/'>www.oxton-digital.com</a></p>
        </div>
              
              </div>
            </div>
          
            </div>
            <div>
             {existError &&
         
              <Popup trigger={buttonPopup} setTrigger={setButtonPopup} onBlur={() => setButtonPopup(false)}>
                <p>{('Merci pour votre message, nous reviendrons vers vous dans les meilleurs délais')}</p>
              </Popup>
            }
            </div>
            </>
          
        )}

  
    </>
  );
};

export default PopupComponent;
